const formatFileName = (fileName) => {
  return fileName
    .toLowerCase()
    .replace(/\s+/g, '_')
    .replace(/-/g, '_')
    .replace(/[^a-z0-9._-]/g, ''); // Remove any characters that aren't lowercase alphanumeric, dots, underscores, or hyphens
};

export default formatFileName;